var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8528 0.250013C9.50507 0.24891 9.16058 0.316908 8.83934 0.450058C8.51811 0.583208 8.22653 0.778856 7.98155 1.02564L0.722173 8.28439C0.629056 8.37765 0.567805 8.49797 0.547173 8.62814L0.00779845 12.0269C-0.00775135 12.1244 2.4166e-05 12.2242 0.0304879 12.3181C0.0609515 12.4121 0.113236 12.4974 0.183058 12.5673C0.25288 12.6371 0.338252 12.6894 0.432178 12.7198C0.526105 12.7503 0.625912 12.7581 0.723423 12.7425L4.1253 12.2031C4.25547 12.1825 4.37578 12.1213 4.46905 12.0281L11.7247 4.76876C12.0948 4.39828 12.3468 3.92635 12.4487 3.41265C12.5506 2.89895 12.4979 2.36657 12.2971 1.88285C12.0964 1.39913 11.7568 0.985801 11.3211 0.695154C10.8854 0.404506 10.3734 0.249594 9.84967 0.250013H9.8528ZM3.7253 11L1.3753 11.375L1.7503 9.02689L6.99405 3.78251L8.9703 5.75876L3.7253 11ZM10.8409 3.88501L9.85342 4.87501L7.8753 2.89689L8.86342 1.90939C9.12955 1.65535 9.48332 1.51361 9.85124 1.51361C10.2191 1.51361 10.5729 1.65535 10.839 1.90939C10.9689 2.03906 11.0718 2.19305 11.1421 2.36254C11.2124 2.53204 11.2485 2.71372 11.2485 2.8972C11.2485 3.08068 11.2124 3.26236 11.1421 3.43186C11.0718 3.60135 10.9689 3.75534 10.839 3.88501H10.8409Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.2e8c9360321cc12603349c02192838fc.svg";
export { ForwardRef as ReactComponent };